import { onBeforeUnmount, watch } from "vue";
function onCustomEvent(el, event, handler) {
  watch(
    () => el.value,
    (element) => {
      if (!element) {
        return;
      }
      element.addEventListener(event, handler);
    },
    { immediate: true }
  );
  onBeforeUnmount(() => {
    if (!el.value) {
      return;
    }
    el.value.removeEventListener(event, handler);
  });
}
export {
  onCustomEvent
};
//# sourceMappingURL=listeners.js.map
